import { Checkbox, Label } from "flowbite-react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ModalFormCheckboxProps {
    register: UseFormRegisterReturn,
    fieldName: string,
    label: string,
}

const ModalFormCheckbox = ({register, fieldName, label}: ModalFormCheckboxProps) => {
    return (
        <div>
            <div className="mb-2 block">
                <Checkbox {...register} />  <Label htmlFor={fieldName} value={label} />
            </div>
        </div>
    )
}

export default ModalFormCheckbox;